export const spacing = {
  none: '0px',
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
  xxxl: '64px',
  
  // Layout utilities
  gutter: '16px',
  containerMaxWidth: '1280px',
  touchTarget: '48px',
};

export default spacing;
